import Api from "@/services/Api";

export default {
    getPeriodosControl() {
        return Api().get("periodos/control");
    },
    savePeriodosControl(periodos, userId) {
        return Api().put("periodos/control", {
            periodos,
            userId
        });
    }
};
